for (const formElem of document.querySelectorAll(".js-form-login")) {
    // Fix for Safari password manager stealing focus when clicking on search
    const emailInput = formElem.querySelector('.js-input-login');
    const passwordInput = formElem.querySelector('.js-input-password');

    if (emailInput && passwordInput) {
        // Track if user is clicking outside the form
        let clickedOutside = false;

        // Detect clicks outside the login form
        document.addEventListener('mousedown', (e) => {
            clickedOutside = !formElem.contains(e.target);
        }, true);

        // Prevent Safari password manager from auto-focusing password field
        // when user clicks away to search or other elements
        passwordInput.addEventListener('focus', (e) => {
            if (clickedOutside && document.activeElement === passwordInput) {
                // User clicked outside form, but password manager forced focus here
                // Blur it immediately to respect user's click target
                setTimeout(() => {
                    if (document.activeElement === passwordInput) {
                        passwordInput.blur();
                    }
                }, 0);
            }
            clickedOutside = false;
        }, true);

        // Also handle email field blur
        emailInput.addEventListener('blur', () => {
            // Small delay to allow click target to be determined
            setTimeout(() => {
                clickedOutside = false;
            }, 50);
        });
    }

    $(formElem).validate({
        rules: {
            login: {
                email: true,
            },
            password: {
                minlength: 8,
            },
        },
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass("is-loading");
            $(".js-login-error").slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(() => {
                Form.ajaxPost(
                    form,
                    function (data) {
                        if (!data.status) {
                            $(".js-login-error").text(data.message).slideDown(250);
                        } else {
                            $(".js-login-success").addClass("is-visible");

                            if (window.location.hash == "#login-modal") {
                                history.pushState("", document.title, window.location.pathname);
                            }

                            // if query contains redirect parameter, redirect to it
                            var urlParams = new URLSearchParams(window.location.search);
                            if (urlParams.has("redirect")) {
                                window.location.href = urlParams.get("redirect");
                            } else {
                                window.location.reload();
                            }
                        }

                        $(form).find('button[type="submit"]').removeClass("is-loading");
                    },
                    "json"
                );
            });
        },
    });
}
